import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_CLEAR_FILTERS,
  AUDIT_RESULTS_SET_SELECTED_AUDITOR_ASSET_ID,
} from '../../../../../actions/actionTypes';

const defaultState = null;

const auditorAssetId = (state = defaultState, action) => {
  switch (action.type) {
    case AUDIT_RESULTS_CLEAR:
    case AUDIT_RESULTS_CLEAR_FILTERS:
      return defaultState;

    case AUDIT_RESULTS_SET_SELECTED_AUDITOR_ASSET_ID:
      return action.payload.assetId ?? null;

    default:
      return state;
  }
};

export default auditorAssetId;
